export default {
  height: "auto",
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchSpan: 5,
  searchMenuSpan: 4,
  menuWidth: 300,
  border: true,
  index: false,
  viewBtn: false,
  delBtn: false,
  addBtn: false,
  editBtn: false,
  selection: true,
  dialogClickModal: false,
  column: [
    {
      label: "",
      prop: "id",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "租赁人",
      prop: "name",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      slot: true
    },
    {
      label: "手机号",
      prop: "phoneNumber",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
    },
    {
      label: "租赁金额",
      prop: "lendingAmount",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
    },
    {
      label: "最近还款日",
      prop: "repaymentDate",
      type: "input",
      slot: "true",
    },
    {
      label: "还款区间",
      prop: "repaymentDateRange",
      hide: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      searchSpan: 5,
      searchMenuSpan: 5,
      searchLabelWidth: 100,
      searchType: "daterange",
      searchRange: true,
      search: true,
      valueFormat: "yyyy-MM-dd",
      searchTip: "最多支持60天的区间查询",
      searchTipPlacement: "top",
    },
    {
      label: "最近期数",
      prop: "currentTenancy",
      type: "input",
      slot: true,
      width: 70,
    },
    {
      label: "每月租金",
      prop: "lendingAmountPer",
      type: "input",
      slot: true,
    },
    {
      label: "状态",
      prop: "businessStatus",
      type: "select",
      slot: true,
    },
    {
      label: "交强险到期",
      prop: "carInsurance1EndDate",
      type: "input",
      width: 95,
    },
    {
      label: "商业险到期",
      prop: "carInsurance2EndDate",
      type: "input",
      width: 95,
    },
    {
      label: "年检到期日期",
      prop: "carInspectionEndDate",
      type: "input",
      width: 95,
    },
    {
      label: "所属代理商",
      prop: "businessDeptName",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
    },
    {
      label: "所属代理商",
      prop: "businessDeptId",
      type: "tree",
      filterable: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchClearable: false,
      searchOrder: 2,
      hide: true,
      dicData: [],
      props: {
        label: "title",
      },
    },
  ],
};
